class AppConfig {
  SessionStatus(status, theme) {
    switch (status) {
      case 1:
        return {
          name: {
            fa: "پرداخت نشده",
          },
          color: theme.warning,
          hasAction: true,
          action: [
            {
              name: {
                fa: "پرداخت",
              },
              roles: ["Student"],
            },
          ],
        };
      case 2:
        return {
          name: {
            fa: "زمان بندی نشده",
          },
          color: theme.primary,
          hasAction: true,
          action: [
            {
              name: {
                fa: "زمانبندی",
              },
              roles: ["Student", "Teacher"],
            },
          ],
        };
      case 3:
        return {
          name: {
            fa: "در انتظار برگزاری",
          },
          color: theme.secondary,
          hasAction: true,
          action: [
            {
              name: {
                fa: "ورود به کلاس",
              },
              roles: ["Student", "Teacher"],
            },
            {
              name: {
                fa: "تعلیق کلاس",
              },
              roles: ["Teacher"],
            },
            {
              name: {
                fa: "زمانبندی مجدد",
              },
              roles: ["Teacher"],
            },
          ],
        };
      case 4:
        return {
          name: {
            fa: "در حال برگزاری ...",
          },
          color: theme.primary,
          hasAction: true,
          action: [
            {
              name: {
                fa: "ورود به کلاس",
              },
              roles: ["Student", "Teacher"],
            },
            {
              name: {
                fa: "تعلیق کلاس",
              },
              roles: ["Teacher"],
            },
          ],
        };
      case 5:
        return {
          name: {
            fa: "برگزار شده",
          },
          color: theme.lightGray,
          hasAction: true,
          action: [
            // after 30 minutes after class show login to class to teacher and student
            {
              name: {
                fa: "ورود به کلاس",
              },
              roles: ["Teacher", "Student"],
            },
            {
              name: {
                fa: "ثبت نظر",
              },
              roles: ["Student"],
            },
          ],
        };
      case 6:
        return {
          name: {
            fa: "تایید شده",
          },
          color: theme.lightGray,
          hasAction: true,
          action: [
            {
              name: {
                fa: "ثبت نظر",
              },
              roles: ["Student"],
            },
          ],
        };
      case 7:
        return {
          name: {
            fa: "لغو شده",
          },
          color: theme.danger,
          hasAction: false,
        };
      case 8:
        return {
          name: {
            fa: "اختلاف",
          },
          color: theme.primary,
          hasAction: false,
        };
      case 9:
        return {
          name: {
            fa: "حل شده",
          },
          color: theme.primary,
          hasAction: false,
        };
      case 10:
        return {
          name: {
            fa: "خاتمه یافته",
          },
          color: theme.lightGray,
          hasAction: false,
        };
      case 11:
        return {
          name: {
            fa: "تعلیق شده",
          },
          color: theme.lightGray,
          hasAction: true,
          action: [
            {
              name: {
                fa: "زمانبندی",
              },
              roles: ["Student", "Teacher"],
            },
          ],
        };
      default:
        return {
          name: {
            fa: "نامشخص",
          },
          color: theme.primary,
          hasAction: false,
        };
    }
  }
  Language(status) {
    const langs = [
      { en: "All", fa: "همه" },
      { en: "English", fa: "انگلیسی" },
      { en: "French", fa: "فرانسه" },
      { en: "German", fa: "آلمانی" },
      { en: "Turkish", fa: "ترکی استانبولی" },
      { en: "Italian", fa: "ایتالیایی" },
      { en: "Chinese", fa: "چینی" },
      { en: "Arabic", fa: "عربی" },
      { en: "Russian", fa: "روسی" },
      { en: "Spanish", fa: "اسپانیایی" },
    ];
    if (langs[parseInt(status)]) {
      return langs[parseInt(status)];
    }
    return {
      fa: "نامشخص",
      en: "Unknown",
    };
  }
  LessonType = (type) => {
    switch (type) {
      case "1":
        return {
          fa: "عمومی",
        };
      case "2":
        return {
          fa: "مکالمه",
        };
      case "2":
        return {
          fa: "کسب و کار",
        };
      case "3":
        return {
          fa: "کودکان",
        };
      case "4":
        return {
          fa: "IELTS",
        };
      case "5":
        return {
          fa: "TOEFL",
        };
      case "PteLesson":
        return {
          fa: "PTE",
        };
      default:
        return {
          fa: "UNKNOWN",
        };
    }
  };
  Category = (cat) => {
    switch (cat) {
      case "GeneralLesson":
        return {
          fa: "عمومی",
        };
      case "ConversationLesson":
        return {
          fa: "مکالمه",
        };
      case "BusinessLesson":
        return {
          fa: "کسب و کار",
        };
      case "KidsLesson":
        return {
          fa: "کودکان",
        };
      case "IeltsLesson":
        return {
          fa: "IELTS",
        };
      case "ToeflLesson":
        return {
          fa: "TOEFL",
        };
      case "PteLesson":
        return {
          fa: "PTE",
        };
      default:
        return {
          fa: "UNKNOWN",
        };
    }
  };
}
export default new AppConfig();
